module.exports = __webpack_public_path__ + "img/bg-welcome.7fa10db8.png";